// import { createSelector } from 'reselect';

export const getIsPosting = state => state.getIn(['reviewNoteDraggable', 'isPosting']);
export const getIsPutting = state => state.getIn(['reviewNoteDraggable', 'isPutting']);
export const getIsPuttingPosition = state => state.getIn(['reviewNoteDraggable', 'isPuttingPosition']);
export const getErrMsg = state => state.getIn(['reviewNoteDraggable', 'errMsg']);

export const getCurrentNoteId = state => state.getIn(['reviewNoteDraggable', 'currentNoteId']);